import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';
import NewsTitle from '../../components/newsTitle';

class Action extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    listView(list = []) {
        return list.map((item, index) => {
            const url = formatUrl(item.url);

            return (
                <li key={index} className={classNames(styles.item, 'clearfix')}>
                    <a className={styles.imgLink} href={url} target="_blank" rel={relText}>
                        <img src={formatImage(item.thumbnails, 270, 200)} alt={item.title} width={270} height={200} />
                    </a>
                    <div className={styles.titleBox}>
                        <h4 className={styles.title}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </h4>
                        <p className={styles.desc}>
                            {item.summary}
                            <a className={styles.xiangxi} href={url} target="_blank" rel={relText}>
                                【详细】
                            </a>
                        </p>
                        <span className={styles.time}>{item.newsTime}</span>
                    </div>
                </li>
            );
        });
    }
    render() {
        const { newsstream, columnId, page, endPage } = this.props.content;
        /* eslint-disable */
        const url = `${gongyiUrl}/shanklist/gongyi/listpage/${columnId}/`;
        /* eslint-enable */

        return (
            <div className={styles.box}>
                <NewsTitle>新闻益事</NewsTitle>
                <ul className={styles.list}>{this.listView(newsstream)}</ul>
                <div className={classNames(styles.nextbox, 'clearfix')}>
                    <a className={classNames(styles.nextpage, styles.mr25)} href={`${url}${page <= 1 ? 1 : page - 1}`}>
                        ◀&nbsp;上一页
                    </a>
                    <a className={styles.nextpage} href={`${url}${page >= endPage ? endPage : page + 1}`}>
                        下一页&nbsp;▶
                    </a>
                </div>
            </div>
        );
    }
}

export default Action;
